import { ComponentsTypes } from '@/constants/componentsTypes';
import { LinkTypes } from '@/constants/linkTypes';
import { Typographies } from '@/schemas/sceneDataSchema';
import { Typography } from '@mui/material';
import { HrefLink } from './formElements/typographies/HrefLink';
import { NavigationLink } from './formElements/typographies/NavigationLink';
import { RouteFn } from '@/hooks/use-flow';
import { TypographyInline } from './formElements/typographies/Typography';
import { ModalLink } from './formElements/typographies/ModalLink';
import { CookieManagementLink } from './formElements/typographies/CookieManagementLink';
import { TypographyAlign, TypographyVariants } from '@/constants/typographyTypes';

interface RichTextProps {
  spans: Typographies[];
  variant?: TypographyVariants;
  align?: TypographyAlign;
  route?: RouteFn;
}

export const RichText: React.FC<RichTextProps> = ({ spans, variant, align, route }) => {
  return (
    <Typography
      align={align}
      variant={variant}
    >
      {spans.map((span, index) => {
        const spanWithVariant = variant ? { ...span, variant: variant } : span;

        switch (spanWithVariant.type) {
          case ComponentsTypes.TYPOGRAPHY:
            return (
              <TypographyInline
                key={index}
                component={spanWithVariant}
              />
            );
          case LinkTypes.COOKIE_MANAGEMENT_LINK:
            return (
              <CookieManagementLink
                key={index}
                component={spanWithVariant}
              />
            );
          case LinkTypes.HREF:
            return (
              <HrefLink
                key={index}
                component={spanWithVariant}
              />
            );
          case LinkTypes.NAVIGATION:
            if (!route) return null;
            return (
              <NavigationLink
                key={index}
                component={spanWithVariant}
                route={route}
              />
            );
          case LinkTypes.MODAL:
            return (
              <ModalLink
                key={index}
                component={spanWithVariant}
              />
            );
          default:
            throw new Error('unknown rich text child');
        }
      })}
    </Typography>
  );
};
